import { PlanmonitorWonenApiServiceModel } from './planmonitor-wonen-api.service.model';
import { InjectionToken } from '@angular/core';

export const PLANMONITOR_WONEN_API_SERVICE = new InjectionToken<PlanmonitorWonenApiServiceModel>('PlanmonitorWonenApiService');
